import * as CL from '@design-system/component-library';
import { dsClass } from '../../common/constants/dsClasses';
import {
  addMsg,
  changeFeeMsg,
  continueShoppingMsg,
  eurosPerMonthCapMsg,
  quantityMsg,
  removeMsg,
  subtractMsg,
  t,
  totalMsg,
} from '../../common/i18n';
import { formatSumToString } from '../../common/utils/priceUtils';
import { getMaxProductSelection } from '../../common/utils/productOfferingsUtils.js';
import { clampQuantity } from '../../common/utils/quantityUtils';
import type { ProductOfferingCartItems, ProductOrderProps } from '../../common/types/shoppingBasketCoCo';

export interface ProductOfferingsModalFooterCoCoProps {
  selectedProductOffers: ProductOfferingCartItems;
  totalPriceInCents: number;
  oneTimeChargeInCents: number;
  hasQuantity?: boolean;
  quantity: number;
  onQuantityChange: (quantity: number) => void;
  onCloseDialog: () => void;
  onOrder: ({ selectedProductOffers }: ProductOrderProps) => void;
  onAddToBasket?: () => void;
}

export const ProductOfferingsModalFooterCoCo = ({
  selectedProductOffers,
  totalPriceInCents,
  oneTimeChargeInCents,
  hasQuantity,
  quantity,
  onQuantityChange,
  onCloseDialog,
  onOrder,
  onAddToBasket,
}: ProductOfferingsModalFooterCoCoProps) => {
  const subcategory = selectedProductOffers.productOfferingType?.subcategory ?? '';

  const handleAddToBasket = () => {
    if (onAddToBasket) {
      onAddToBasket();
    } else {
      onCloseDialog();
      onOrder({ selectedProductOffers, quantity });
    }
  };
  return (
    <div className="of-subscription-modal-footer ds-border--top-style-solid">
      <div className="of-subscription-modal-footer-content">
        <CL.Price
          currentPrice={`${t.CEQ2(totalMsg)}: ${formatSumToString(totalPriceInCents, true)}`}
          currentPriceUnit={t.H37G(eurosPerMonthCapMsg)}
          additionalInfo={`${t.ZRKX(changeFeeMsg)} ${formatSumToString(oneTimeChargeInCents, true)} €, Alv 0%`}
          size="s"
        />
        <div className="of-subscription-modal-footer-buttons">
          <div className="of-subscription-modal-footer-buttons-quantity">
            <div
              className={`of-subscription-modal-footer-buttons-quantity-label ${dsClass.MARGIN_BOTTOM_1} ${dsClass.MARGIN_TOP_3} ${dsClass.HIDE_M_AND_UP}`}
            >
              <span className={`${dsClass.TEXT_L} ${dsClass.FONT_WEIGHT_700}`}>{t.M0W7(quantityMsg)}</span>
            </div>
            {hasQuantity && (
              <CL.Quantity
                className={`of-subscription-quantity ${dsClass.MARGIN_RIGHT_2}`}
                i18n_quantity_deleteAriaLabel={t.R3VE(removeMsg)}
                i18n_quantity_minusAriaLabel={t.C2KQ(subtractMsg)}
                i18n_quantity_plusAriaLabel={t.VKFM(addMsg)}
                i18n_quantity_quantityAriaLabel={t.M0W7(quantityMsg)}
                minValue={1}
                maxValue={getMaxProductSelection(subcategory)}
                currentValue={quantity}
                onChange={(q: number) => onQuantityChange(clampQuantity(q))}
              />
            )}
          </div>
          <div className="of-subscription-modal-footer-buttons-add-to-cart">
            <CL.Button onClick={() => onCloseDialog()} color="link" className={dsClass.HIDE_M_AND_UP}>
              {t.VLZR(continueShoppingMsg)}
            </CL.Button>
            <CL.Button onClick={handleAddToBasket} size="l">
              {t.B5J1('Add to basket')}
            </CL.Button>
          </div>
        </div>
      </div>
    </div>
  );
};
